module.exports = __webpack_public_path__ + "img/popUpImage.1aa6127b.svg";